import { IonIcon, IonLabel } from '@ionic/react'
import { eye, eyeOff } from 'ionicons/icons'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { logEvent } from '../../../../analytics/utils/firebaseUtils'

interface MarkedPeriodsToggleProps {
	showMarkedPeriods: boolean
	setShowMarkedPeriods: (newValue: 'enabled' | 'disabled') => void
}

const MarkedPeriodsToggle: FC<MarkedPeriodsToggleProps> = ({
	showMarkedPeriods,
	setShowMarkedPeriods,
}) => {
	const { t } = useTranslation('pages_electricity')

	const activeStyle =
		'button text-brand-secondary-100-light dark:text-white dark:[&>ion-icon]:bg-brand-primary-100-dark [&>ion-icon]:bg-brand-primary-100-light [&>ion-icon]:text-white hover cursor-pointer select-none'
	const inactiveStyle =
		'button text-[#707070] dark:text-brand-primary-100-dark dark:[&>ion-icon]:bg-[#144448] [&>ion-icon]:bg-[#e5e5e5] [&>ion-icon]:text-[#a3a3a3] dark:[&>ion-icon]:text-brand-primary-100-dark hover cursor-pointer select-none'

	const toggle = () => {
		logEvent('click-toggle-marked-periods', { value: !showMarkedPeriods })
		setShowMarkedPeriods(showMarkedPeriods === false ? 'enabled' : 'disabled')
	}

	return (
		<div className='chart-buttons w-full flex flex-col gap-4 bg-white dark:bg-[#0d2d30]'>
			<div className='flex flex-row items-center justify-center gap-2'>
				<div
					className={showMarkedPeriods ? activeStyle : inactiveStyle}
					onClick={toggle}
					role='button'
					tabIndex={0}
					onKeyDown={e => {
						if (e.key === 'Enter' || e.key === ' ') {
							e.preventDefault()
							toggle()
						}
					}}
					aria-pressed={showMarkedPeriods}
					aria-label={
						showMarkedPeriods ? t('markedPeriodsToggle.hide') : t('markedPeriodsToggle.show')
					}
				>
					<IonIcon icon={showMarkedPeriods ? eye : eyeOff} />
					<IonLabel className='tracking-wide'>
						{showMarkedPeriods ? t('markedPeriodsToggle.hide') : t('markedPeriodsToggle.show')}
					</IonLabel>
				</div>
			</div>
		</div>
	)
}

export default MarkedPeriodsToggle
